import React from "react";
import { motion } from "framer-motion";
import { Briefcase, Calendar } from "lucide-react";
import { Badge } from "../ui/badge";
import portfolioData from "../../data/mock";

const ExperienceTimeline = () => {
  const { experience } = portfolioData;

  return (
    <section id="experience" className="relative py-28 bg-zinc-950">
      {/* Section separator */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-zinc-800 to-transparent" />

      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-emerald-400" />
            <span className="text-emerald-400 text-sm font-medium tracking-wider uppercase">
              Experience
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            Work History
          </h2>
        </motion.div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-0 md:left-8 top-0 bottom-0 w-px bg-zinc-800" />

          <div className="space-y-12">
            {experience.map((job, index) => (
              <motion.div
                key={job.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                className="relative pl-8 md:pl-20"
              >
                {/* Timeline dot */}
                <div className="absolute left-0 md:left-8 top-2 -translate-x-1/2 w-3 h-3 rounded-full border-2 border-emerald-400 bg-zinc-950" />

                <div className="group p-6 rounded-xl border border-zinc-800/60 bg-zinc-900/20 hover:border-emerald-500/20 hover:bg-zinc-900/40 transition-all duration-300">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-4">
                    <div>
                      <h3 className="text-xl font-semibold text-white">
                        {job.role}
                      </h3>
                      <div className="flex items-center gap-2 text-emerald-400 text-sm mt-1">
                        <Briefcase size={14} />
                        <span>{job.company}</span>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 text-zinc-500 text-sm">
                      <Calendar size={14} />
                      <span>{job.period}</span>
                    </div>
                  </div>

                  <p className="text-zinc-400 text-sm leading-relaxed mb-5">
                    {job.description}
                  </p>

                  <div className="flex flex-wrap gap-2">
                    {job.skills.map((skill) => (
                      <Badge
                        key={skill}
                        variant="secondary"
                        className="bg-zinc-800/80 text-zinc-300 border-zinc-700/50 hover:bg-zinc-800 text-xs font-normal"
                      >
                        {skill}
                      </Badge>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceTimeline;
